export default {
  headerContent: {
    title: 'Mapfre Sigorta Tamamlayıcı Sağlık Sigortası Teklifi',
    slogan: "Tamamlayıcı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TAMAMLAYICI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'Mapfre Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Kendiniz veya aileniz için doğru sağlık planını bulmanıza yardımcı olalım. Temel bilgileri bilmek, sizin veya aileniz için doğru olan sağlık sigortası planını seçmenize yardımcı olacaktır. ',
        'Mapfre Sigorta’nın tamamlayıcı sağlık sigortası ürünü Fark Yok Tamamlayıcı Sağlık Sigortasıdır.',
        'Tamamlayıcı sağlık sigortası sosyal güvencesi bulunan bireylerin özel hastanelerde tedavi hizmeti almanızı sağlamaktadır. ',
        'Mapfre Sigorta tamamlayıcı sağlık sigortası SGK ile anlaşmalı özel hastaneler kaza veya hastalık sonucu alınması gereken tedavi hizmeti sonucunda oluşan maddi giderlere karşı koruma sağlamaktadır.'
      ]
    },
    subContent: {
      title:
        'Mapfre Sigorta Tamamlayıcı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası teminatları yatarak ve ayakta tedavi teminatlarını kapsar. ',
          subList: null
        },
        {
          paragraph:
            'Yatarak tedavi, hastanede 24 saati aşan yatış gerektiren tedavileri kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Ameliyat',
            'Hastanede tedavi',
            'Kemoterapi, Radyoterapi',
            'Oda / Yemek/ Refakatçi',
            'Acil ulaşım Ambulans',
            'Suni uzuv',
            'Tıbbi malzeme',
            'Evde Bakım'
          ]
        },
        {
          paragraph:
            'Ayakta tedavi, hastanede 24 saati aşmayan yatış gerektirmeyen tedavileri kapsamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Ayakta Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Doktor Muayene',
            'Laboratuvar',
            'Görüntüleme',
            'Modern Teşhis ( MR, Tomografi vb.)',
            'Fizik Tedavi Teminatıdır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle:
    'Mapfre Sigorta Tamamlayıcı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
